// (Apple Pay preference is handled by setupSingleWallet below — it filters the
// accelerated-checkout wallet-configs to a single preferred wallet on every
// viewport, so no CSS class flag or stack-shifting is needed.)

// CART DRAWER
const drawer = document.querySelector('[data-cart-drawer]');
const menuDrawer = document.querySelector('[data-menu-drawer]');

function openDrawer(el) {
  el?.classList.add('is-open');
  el?.setAttribute('aria-hidden', 'false');
  if (el === drawer) {
    document.body.classList.add('cart-open');
    // Re-sync the express checkout button (Apple Pay / Shop Pay) every time the
    // cart opens. The accelerated-checkout web component only renders its buttons
    // once it's initialised WHILE VISIBLE; if the cart was empty (block hidden)
    // at page load — which is the usual case on the homepage / shop-all — the
    // component never upgraded, so the button appeared to exist only on the
    // product page. Unhiding + re-initialising on open makes it show everywhere.
    const countEl = document.querySelector('[data-cart-count]');
    const count = countEl ? (parseInt(countEl.textContent, 10) || 0) : 1;
    if (typeof syncWalletButtons === 'function') syncWalletButtons(count);
  }
}
function closeDrawer(el) {
  el?.classList.remove('is-open');
  el?.setAttribute('aria-hidden', 'true');
  if (el === drawer) document.body.classList.remove('cart-open');
}

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-cart-toggle]')) {
    e.preventDefault();
    if (drawer?.classList.contains('is-open')) { closeDrawer(drawer); }
    else { openDrawer(drawer); closeDrawer(menuDrawer); }
  }
  if (e.target.closest('[data-cart-close]')) { closeDrawer(drawer); }
  if (e.target.closest('[data-menu-toggle]')) {
    e.preventDefault();
    // True toggle: pressing + again closes the menu instead of re-opening it.
    if (menuDrawer?.classList.contains('is-open')) { closeDrawer(menuDrawer); }
    else { openDrawer(menuDrawer); closeDrawer(drawer); }
  }
  if (e.target.closest('[data-menu-close]')) { closeDrawer(menuDrawer); }
});

// Single global Escape handler — closes whatever's open.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  closeDrawer(drawer);
  closeDrawer(menuDrawer);
  document.querySelectorAll('[data-locale-menu]').forEach(m => m.hidden = true);
  document.querySelectorAll('[data-locale-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  if (typeof closeNotify === 'function') closeNotify();
  if (typeof closeSizing === 'function') closeSizing();
  if (typeof closeSignupPopup === 'function') closeSignupPopup();
});

// LOCALE / CURRENCY PICKER
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-locale-toggle]');
  const insideMenu = e.target.closest('[data-locale-menu]');
  document.querySelectorAll('[data-locale-pill]').forEach(pill => {
    const menu = pill.querySelector('[data-locale-menu]');
    const btn = pill.querySelector('[data-locale-toggle]');
    if (!menu || !btn) return;
    if (toggle && pill.contains(toggle)) {
      menu.hidden = !menu.hidden;
      btn.setAttribute('aria-expanded', String(!menu.hidden));
    } else if (!insideMenu) {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
  });
});

// Refresh cart drawer contents using Shopify's Section Rendering API.
//
// We used to rebuild the cart HTML client-side from /cart.js. That stripped the
// dynamic checkout buttons (Apple Pay / Shop Pay / Google Pay) because their
// HTML is rendered server-side with secure tokens that can't be reconstructed
// in JS — and the "preserve the existing node" trick failed whenever the cart
// went from empty → has items, because the empty-cart branch of the Liquid
// template doesn't render the wallet button block at all. Result: Apple Pay
// only showed up on the *second* page load (when the server rendered the cart
// already-populated).
//
// Fix: fetch the `main-cart` section fresh from the cart page (Section
// Rendering API), pull out its [data-cart-content] block (which is rendered
// via the `cart-drawer-contents` snippet), and swap it into every
// [data-cart-content] container on the page (the drawer always, and the /cart
// page if we're on it). The wallet buttons come with valid server-issued
// tokens against the current cart, so Apple Pay shows up on first add.
//
// (We use main-cart instead of a cart-drawer section because Shopify's Section
// Rendering API doesn't expose sections rendered via `{% section %}` in a
// layout — only sections rendered through templates or section groups.)

// Bundle suggestions — config comes from the cart-drawer section's blocks,
// serialized into [data-bundle-config] in the persistent drawer shell.
function getBundleConfig() {
  // Parsed fresh on every cart rebuild (cheap) — caching broke the theme
  // editor, which re-renders the section with new blocks mid-session.
  const el = document.querySelector('[data-bundle-config]');
  if (!el) return [];
  try { return (JSON.parse(el.textContent) || []).filter(Boolean); }
  catch (_) { return []; }
}

// First bundle whose trigger product is in the cart while its suggestion
// isn't → "complete the set" card. Returns '' when nothing applies.
function renderBundleCard(b, ids) {
  const pieces = b.pieces;
  // Offer only pieces missing from the cart AND purchasable; the card still
  // shows the whole set (images, subtitle, set price).
  const missing = pieces.filter(p => !ids.has(p.id));
  const offerable = missing.filter(p => p.variants.some(v => v.available));
  if (!missing.length || !offerable.length) return '';

  const full = pieces.reduce((t, p) => t + p.price, 0);
  const pct = b.savePct || 0;
  const bundlePrice = pct ? Math.round(full * (100 - pct) / 100) : full;

  const availOf = p => p.variants.filter(v => v.available);
  const isSingle = p => { const a = availOf(p); return a.length === 1 && a[0].title === 'default title'; };
  const allSingle = offerable.every(isSingle);

  let controls, pieceRows = '';
  if (allSingle) {
    const idsCsv = offerable.map(p => availOf(p)[0].id).join(',');
    controls = `<button type="button" class="cart-bundle__plus" data-bundle-add-multi="${idsCsv}" aria-label="add set to cart">+</button>`;
  } else {
    // Select sizes for every piece first, then one confirm adds the whole set —
    // no cart rebuild (and no scroll reset) until the customer confirms.
    controls = `<button type="button" class="cart-bundle__plus" data-bundle-size-toggle aria-label="choose sizes">+</button>`;
    const sizedCount = offerable.filter(p => !isSingle(p)).length;
    pieceRows = `<div class="cart-bundle__pieces" hidden>${
      offerable.map(p => {
        const a = availOf(p);
        if (isSingle(p)) {
          return `
        <div class="cart-bundle__piece" data-piece data-selected="${a[0].id}">
          <span class="cart-bundle__piece-name">${p.title}</span>
          <span class="cart-bundle__size is-selected cart-bundle__size--static">one size</span>
        </div>`;
        }
        return `
        <div class="cart-bundle__piece" data-piece>
          <span class="cart-bundle__piece-name">${p.title}</span>
          ${a.map(v => `<button type="button" class="cart-bundle__size" data-bundle-pick="${v.id}">${v.title}</button>`).join('')}
        </div>`;
      }).join('')
    }
      <button type="button" class="cart-bundle__confirm" data-bundle-confirm disabled>choose sizes (0/${sizedCount})</button>
    </div>`;
  }

  // Custom bundle shot (block setting) replaces the per-piece tiles.
  const tiles = b.image
    ? `<span class="cart-bundle__imgtile cart-bundle__imgtile--wide"><img src="${b.image}" width="720" height="450" alt="" loading="lazy" decoding="async"></span>`
    : pieces.map(p =>
        `<a href="${p.url}" class="cart-bundle__imgtile">${p.image ? `<img src="${p.image}" width="160" height="160" alt="" loading="lazy" decoding="async">` : ''}</a>`
      ).join('');
  const subtitle = pieces.map(p => p.title).join(' + ');

  return `
    <div class="cart-bundle">
      ${pct ? `<span class="cart-bundle__badge">save ${pct}%</span>` : ''}
      <div class="cart-bundle__imgs">${tiles}</div>
      <a href="${offerable[0].url}" class="cart-bundle__name">${b.name || subtitle}</a>
      <div class="cart-bundle__sub">${subtitle}</div>
      <div class="cart-bundle__pricerow">
        <span class="cart-bundle__price">${formatMoney(bundlePrice)}</span>
        ${pct ? `<span class="cart-bundle__compare">${formatMoney(full)}</span>` : ''}
        ${controls}
      </div>
      ${pieceRows}
    </div>`;
}

// SET UPGRADE — the cart holds a piece, offer the set product instead.
// Unlike a bundle (which adds the missing pieces), this REPLACES the pieces
// in the cart with a single catalogue product, so the shopper ends up with
// one line item at the set price rather than two discounted ones.
function getUpgradeConfig() {
  const el = document.querySelector('[data-upgrade-config]');
  if (!el) return [];
  try { return (JSON.parse(el.textContent) || []).filter(Boolean); }
  catch (_) { return []; }
}

function buildUpgradeHtml(cart) {
  const items = cart.items || [];
  if (!items.length) return '';

  for (const u of getUpgradeConfig()) {
    const pieces = (u.pieces || []).filter(Boolean);
    if (!pieces.length || !u.target) continue;

    const pieceIds = new Set(pieces.map(p => p.id));
    // Already holding the set — nothing to offer.
    if (items.some(i => i.product_id === u.target.id)) continue;

    const inCart = items.filter(i => pieceIds.has(i.product_id));
    if (!inCart.length) continue;
    // Quantities above one would make "swap these for one set" lose items.
    if (inCart.some(i => i.quantity !== 1)) continue;

    // Size comes from what is already in the cart, so the swap is one tap.
    const size = (inCart[0].variant_title || '').toLowerCase();
    const match = (u.target.variants || []).find(v => v.title === size && v.available);
    if (!match) continue;

    const full = pieces.reduce((t, p) => t + p.price, 0);
    const save = full - u.target.price;
    if (save <= 0) continue;

    const keys = inCart.map(i => i.key).join(',');
    return `
      <div class="cart-bundles">
        <div class="cart-bundle cart-bundle--upgrade">
          <span class="cart-bundle__badge">save ${formatMoney(save)}</span>
          ${u.image ? `<div class="cart-bundle__imgs">
            <span class="cart-bundle__imgtile cart-bundle__imgtile--wide">
              <img src="${u.image}" width="720" height="450" alt="" loading="lazy" decoding="async">
            </span>
          </div>` : ''}
          <a href="${u.target.url}" class="cart-bundle__name">${u.name}</a>
          <div class="cart-bundle__sub">${u.sub || pieces.map(p => p.title).join(' + ')}</div>
          <div class="cart-bundle__pricerow">
            <span class="cart-bundle__price">${formatMoney(u.target.price)}</span>
            <span class="cart-bundle__compare">${formatMoney(full)}</span>
            <button type="button" class="cart-bundle__plus"
                    data-upgrade-swap="${match.id}" data-upgrade-remove="${keys}"
                    aria-label="swap for the set">+</button>
          </div>
        </div>
      </div>`;
  }
  return '';
}

// Add the set, then zero the lines it replaces. Two calls because
// /cart/update.js can only change lines that already exist.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-upgrade-swap]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.dataset.upgradeSwap), quantity: 1 })
    });
    const updates = {};
    (btn.dataset.upgradeRemove || '').split(',').filter(Boolean).forEach(k => { updates[k] = 0; });
    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    }
    await refreshCart();
  } catch (err) {
    console.error(err);
    btn.disabled = false;
  }
});

function buildBundleHtml(cart) {
  const bundles = getBundleConfig();
  if (!bundles.length || !cart.items.length) return '';
  const ids = new Set(cart.items.map(i => i.product_id));

  // A bundle is triggered when the cart holds ANY of its pieces.
  const applicable = [];
  for (const b of bundles) {
    b.pieces = (b.pieces || []).filter(Boolean);
    if (b.pieces.length < 2) continue;
    const card = renderBundleCard(b, ids);
    if (!card) continue;
    applicable.push({ card, triggered: b.pieces.some(p => ids.has(p.id)) });
  }
  if (!applicable.length) return '';

  applicable.sort((a, b) => (b.triggered ? 1 : 0) - (a.triggered ? 1 : 0));
  if (!applicable[0].triggered) return '';

  let html = applicable[0].card;
  if (applicable.length > 1) {
    html += `
      <button type="button" class="cart-bundle-more__toggle" data-bundles-open>
        view all bundles (${applicable.length}) →
      </button>`;
  }
  return `<div class="cart-bundles">${html}</div>`;
}

// Fill the slide-in "all bundles" page with every applicable bundle.
function updateBundlesPage(cart) {
  const list = document.querySelector('[data-bundles-list]');
  if (!list) return;
  const ids = new Set((cart.items || []).map(i => i.product_id));
  const cards = [];
  for (const b of getBundleConfig()) {
    b.pieces = (b.pieces || []).filter(Boolean);
    if (b.pieces.length < 2) continue;
    const card = renderBundleCard(b, ids);
    if (card) cards.push(card);
  }
  list.innerHTML = cards.length
    ? cards.join('')
    : '<p class="cart-drawer__bundles-empty">no bundles available right now</p>';
}

// Slide the bundles page in/out; close it whenever the cart itself closes.
document.addEventListener('click', (e) => {
  const page = document.querySelector('[data-bundles-page]');
  if (!page) return;
  if (e.target.closest('[data-bundles-open]')) {
    // On the /cart page the drawer is closed — the bundles panel lives inside
    // it, so open the drawer as a host. Remember that we auto-opened it: the
    // panel then behaves like a page overlay, and closing it closes the
    // drawer too instead of revealing a duplicate cart.
    const drawerEl = document.querySelector('[data-cart-drawer]');
    if (drawerEl && !drawerEl.classList.contains('is-open')) {
      openDrawer(drawerEl);
      drawerEl.dataset.bundlesAutoOpened = '1';
    }
    page.classList.add('is-open');
    page.setAttribute('aria-hidden', 'false');
  } else if (e.target.closest('[data-bundles-back]') || e.target.closest('[data-cart-close]')) {
    page.classList.remove('is-open');
    page.setAttribute('aria-hidden', 'true');
    const drawerEl = document.querySelector('[data-cart-drawer]');
    if (drawerEl && drawerEl.dataset.bundlesAutoOpened) {
      delete drawerEl.dataset.bundlesAutoOpened;
      closeDrawer(drawerEl);
    }
  }
});

// After a bundle add: slide back to the main cart and scroll to the top of
// the items list, where the completed set renders as a group — the customer
// sees what they just added instead of the next suggestion.
function returnToCart() {
  const page = document.querySelector('[data-bundles-page]');
  if (page) {
    page.classList.remove('is-open');
    page.setAttribute('aria-hidden', 'true');
  }
  // If the drawer was only opened to host the bundles panel (cart page flow),
  // close it entirely — the page's own cart is the destination there.
  const drawerEl = document.querySelector('[data-cart-drawer]');
  if (drawerEl && drawerEl.dataset.bundlesAutoOpened) {
    delete drawerEl.dataset.bundlesAutoOpened;
    closeDrawer(drawerEl);
    return;
  }
  const items = document.querySelector('[data-cart-drawer] .cart-drawer__items');
  if (items) items.scrollTop = 0;
}

// Grouped set: show/hide the individual piece lines.
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-group-toggle]');
  if (!t) return;
  const lines = t.closest('.cart-group').querySelector('.cart-group__lines');
  if (!lines) return;
  const open = lines.hasAttribute('hidden');
  if (open) lines.removeAttribute('hidden'); else lines.setAttribute('hidden', '');
  t.textContent = open ? t.dataset.labelOpen : t.dataset.labelClosed;
});

// Grouped set: remove every piece in one request.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-group-remove]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  try {
    const updates = {};
    btn.dataset.groupRemove.split(',').forEach(k => { updates[k] = 0; });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    await refreshCart();
  } catch (err) { console.error(err); btn.disabled = false; }
});

// Size pill selection inside the bundle chooser — selects, does NOT add yet.
document.addEventListener('click', (e) => {
  const pick = e.target.closest('[data-bundle-pick]');
  if (!pick) return;
  const piece = pick.closest('[data-piece]');
  piece.querySelectorAll('[data-bundle-pick]').forEach(b => b.classList.remove('is-selected'));
  pick.classList.add('is-selected');
  piece.setAttribute('data-selected', pick.dataset.bundlePick);

  const pane = pick.closest('.cart-bundle__pieces');
  const sized = [...pane.querySelectorAll('[data-piece]')].filter(el => el.querySelector('[data-bundle-pick]'));
  const done = sized.filter(el => el.getAttribute('data-selected')).length;
  const confirm = pane.querySelector('[data-bundle-confirm]');
  if (!confirm) return;
  if (done >= sized.length) {
    confirm.disabled = false;
    confirm.textContent = 'add set';
  } else {
    confirm.textContent = `choose sizes (${done}/${sized.length})`;
  }
});

// Confirm — batch-add every selected piece in one request, then rebuild.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-bundle-confirm]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  btn.textContent = 'adding\u2026';
  try {
    const items = [...btn.closest('.cart-bundle__pieces').querySelectorAll('[data-piece]')]
      .map(el => el.getAttribute('data-selected'))
      .filter(Boolean)
      .map(id => ({ id: parseInt(id), quantity: 1 }));
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    await refreshCart();
    returnToCart();
  } catch (err) {
    console.error(err);
    btn.disabled = false;
    btn.textContent = 'add set';
  }
});

// "+" on sized bundles reveals the per-piece size chooser.
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-bundle-size-toggle]');
  if (!t) return;
  const pieces = t.closest('.cart-bundle').querySelector('.cart-bundle__pieces');
  if (pieces) pieces.toggleAttribute('hidden');
});

// One-tap add of a whole set (all pieces one-size).
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-bundle-add-multi]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  try {
    const items = btn.dataset.bundleAddMulti.split(',').map(id => ({ id: parseInt(id), quantity: 1 }));
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    await refreshCart();
    returnToCart();
  } catch (err) { console.error(err); btn.disabled = false; }
});


// Theme editor: re-render of the cart-drawer section replaces its HTML —
// rebuild so the items and suggestion reflect the live cart again.
document.addEventListener('shopify:section:load', () => refreshCart());

// The server-rendered drawer HTML has no suggestion card — rebuild once on
// load so carts that already contain a trigger product show it immediately.
// (Restored: an earlier edit accidentally removed this block.)
(function () {
  function initialBundleRefresh() {
    if (!getBundleConfig().length) return;
    // Server already rendered an empty cart — nothing to group or suggest,
    // skip the extra /cart.js round-trip on first paint.
    const badge = document.querySelector('[data-cart-count]');
    if (badge && badge.textContent.trim() === '0') return;
    refreshCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialBundleRefresh);
  } else {
    initialBundleRefresh();
  }
})();

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-bundle-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.dataset.bundleAdd), quantity: 1 })
    });
    await refreshCart();
  } catch (err) { console.error(err); btn.disabled = false; }
});

// Free-shipping progress. Must produce markup identical to the Liquid in
// snippets/cart-drawer-contents.liquid — this rebuild replaces that output on
// every cart change, so if the two drift the bar appears on load and then
// vanishes the moment you touch a quantity.
// Config comes from the persistent drawer shell (see sections/cart-drawer.liquid).
// data-free-ship is 0 outside Lithuania, where the threshold doesn't apply.
function shipHtml(cart) {
  const shell = document.querySelector('[data-cart-drawer]');
  if (!shell || shell.dataset.freeShip !== '1') return '';
  const min = parseInt(shell.dataset.freeShipMin, 10);
  if (!min || min <= 0) return '';
  const remaining = min - cart.total_price;
  if (remaining > 0) {
    const pct = Math.min(100, Math.round((cart.total_price * 100) / min));
    return `
        <div class="cart-ship">
          <div class="cart-ship__label">you're ${formatMoney(remaining)} away from free shipping</div>
          <div class="cart-ship__track"><span class="cart-ship__fill" style="width:${pct}%"></span></div>
        </div>`;
  }
  return `
        <div class="cart-ship cart-ship--done">
          <div class="cart-ship__label">free shipping unlocked</div>
          <div class="cart-ship__track"><span class="cart-ship__fill" style="width:100%"></span></div>
        </div>`;
}

// True only when the cart already qualifies, so the totals row can say "free"
// instead of the abandonment-inducing "calculated at checkout".
function shipIsFree(cart) {
  const shell = document.querySelector('[data-cart-drawer]');
  if (!shell || shell.dataset.freeShip !== '1') return false;
  const min = parseInt(shell.dataset.freeShipMin, 10);
  return !!min && cart.total_price >= min;
}

async function refreshCart() {
  try {
    // 1) Rebuild line items + totals + checkout button client-side from /cart.js.
    //    This is theme-independent and always reflects the current cart, so the
    //    drawer can never come back empty after an add (the regression we hit
    //    when we relied solely on the Section Rendering API).
    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    if (!cartRes.ok) return;
    const cart = await cartRes.json();

    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);

    // Update EVERY cart container on the page — the drawer always exists, and
    // the /cart page has its own [data-cart-content] card that must stay in
    // sync too (it went stale after qty changes when only the first matching
    // container was rebuilt).
    const containers = document.querySelectorAll('[data-cart-content]');
    if (!containers.length) return;

    // The wallet buttons (Apple Pay / Shop Pay) live in the persistent shell
    // OUTSIDE [data-cart-content], so they survive this rebuild. Just toggle
    // their visibility with the cart count and nudge Shopify to re-render them
    // against the new cart state.
    syncWalletButtons(cart.item_count);

    // Bundle suggestions are strictly additive — if anything in their
    // pipeline throws, the cart items must still render.
    let bundleHtml = '';
    try { bundleHtml = buildUpgradeHtml(cart); } catch (e) { console.error('upgrade suggestion error', e); }
    // The upgrade wins when both apply: swapping to the set is a better offer
    // than being sold the missing piece at a few percent off.
    if (!bundleHtml) {
      try { bundleHtml = buildBundleHtml(cart); } catch (e) { console.error('bundle suggestion error', e); }
    }

    let html;
    if (cart.item_count === 0) {
      html = `<div class="cart-drawer__empty"><p style="text-transform:uppercase; letter-spacing:0.1em; font-size:12px;">your cart is empty</p></div>`;
    } else {
      const lineHtml = (item, i) => `
        <div class="cart-line" data-line="${i + 1}">
          <a href="${item.url}" class="cart-line__img">${item.image ? `<img src="${cartImageUrl(item.image, 200)}" width="200" height="200" alt="" loading="lazy" decoding="async">` : ''}</a>
          <div>
            <div class="cart-line__head">
              <a href="${item.url}" class="cart-line__title">${(item.product_title || '').toLowerCase()}</a>
              <span class="cart-line__price">${formatMoney(item.final_line_price)}</span>
            </div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title.toLowerCase()}</div>` : ''}
            <div class="cart-line__bottom">
              <div class="qty">
                <button type="button" data-qty-down="${i + 1}" aria-label="decrease">−</button>
                <span>qty ${item.quantity}</span>
                <button type="button" data-qty-up="${i + 1}" aria-label="increase">+</button>
              </div>
              <button type="button" class="cart-line__remove" data-remove="${i + 1}">delete</button>
            </div>
          </div>
        </div>
      `;

      // Group complete bundles: when every piece of a configured bundle is in
      // the cart, its lines render inside one framed group with the bundle
      // name + save badge, so the set reads as a set. Item indexes are the
      // original cart indexes, so qty/remove controls keep working.
      let groupsHtml = '';
      const claimed = new Set();
      try {
        // Bigger sets claim their items first — otherwise a small bundle that
        // overlaps a large one (e.g. a 2-piece subset of the 5-piece set)
        // steals pieces and the large set can never group.
        const grouping = getBundleConfig()
          .map(b => ({ ...b, pieces: (b.pieces || []).filter(Boolean) }))
          .filter(b => b.pieces.length >= 2)
          .sort((a, b) => b.pieces.length - a.pieces.length);
        for (const b of grouping) {
          const pieces = b.pieces;
          const memberIdx = [];
          let complete = true;
          for (const p of pieces) {
            const idx = cart.items.findIndex((it, i) => it.product_id === p.id && !claimed.has(i));
            if (idx === -1) { complete = false; break; }
            memberIdx.push(idx);
          }
          if (!complete) continue;
          memberIdx.forEach(i => claimed.add(i));
          const memberItems = memberIdx.map(i => cart.items[i]);
          // Real numbers from Shopify: the automatic BXGY discounts now apply
          // in the cart itself, so the set price comes from actual line-level
          // discounts — never estimated, never double-counted. The set covers
          // one unit per piece; extra quantities are full price by the
          // discount's own once-per-order rule.
          // /cart.js: line_price is ALREADY discounted (alias of final_line_price);
          // the pre-discount figures are original_price / original_line_price.
          const setTotal = memberItems.reduce((t, it) => t + (it.original_price != null ? it.original_price : it.price), 0);
          const realDiscount = memberItems.reduce((t, it) => {
            const orig = it.original_line_price != null ? it.original_line_price : it.line_price;
            return t + (orig - it.final_line_price);
          }, 0);
          const setReal = setTotal - realDiscount;
          const hasExtras = memberItems.some(it => it.quantity > 1);
          const gPct = realDiscount > 0 ? (b.savePct || 0) : 0;
          const totalHtml = realDiscount > 0
            ? `${formatMoney(setReal)} <s class="cart-group__compare">${formatMoney(setTotal)}</s>`
            : formatMoney(setTotal);
          const sizes = memberItems
            .map(it => it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.toLowerCase() : 'one size')
            .join(' / ') + (hasExtras ? ' · extras at full price' : '');
          const keysCsv = memberItems.map(it => it.key).join(',');
          const lines = memberIdx.map(i => lineHtml(cart.items[i], i)).join('');
          if (b.image) {
            // Custom bundle shot → the set renders as ONE entity; individual
            // piece lines stay available behind "manage pieces".
            groupsHtml += `
            <div class="cart-group cart-group--custom">
              <div class="cart-group__head">
                <span class="cart-group__name">${b.name || 'bundle'}</span>
                ${gPct ? `<span class="cart-group__badge">save ${gPct}%</span>` : ''}
              </div>
              <span class="cart-group__img"><img src="${b.image}" width="720" height="450" alt="" loading="lazy" decoding="async"></span>
              <div class="cart-group__meta">
                <span class="cart-group__sizes">${sizes}</span>
                <span class="cart-group__total">${totalHtml}</span>
              </div>
              <div class="cart-group__actions">
                <button type="button" class="cart-group__action" data-group-toggle
                        data-label-open="hide pieces" data-label-closed="manage pieces">manage pieces</button>
                <button type="button" class="cart-group__action cart-group__action--remove" data-group-remove="${keysCsv}">delete set</button>
              </div>
              <div class="cart-group__lines" hidden>${lines}</div>
            </div>`;
          } else {
            groupsHtml += `
            <div class="cart-group">
              <div class="cart-group__head">
                <span class="cart-group__name">${b.name || 'bundle'}</span>
                ${gPct ? `<span class="cart-group__badge">save ${gPct}%</span>` : ''}
              </div>
              ${lines}
              <div class="cart-group__meta cart-group__meta--footer">
                <span class="cart-group__sizes">set total</span>
                <span class="cart-group__total">${totalHtml}</span>
              </div>
            </div>`;
          }
        }
      } catch (e) { console.error('bundle grouping error', e); }

      const lines = groupsHtml + cart.items.map((item, i) => claimed.has(i) ? '' : lineHtml(item, i)).join('');
      html = `
        <div class="cart-drawer__items" data-cart-items>${lines}${bundleHtml}</div>
        ${shipHtml(cart)}
        <div class="cart-drawer__totals">
          <div class="cart-drawer__totals-row cart-drawer__totals-row--muted"><span>shipping</span><span>${shipIsFree(cart) ? 'free' : 'calculated at checkout'}</span></div>
          <div class="cart-drawer__totals-row"><span>subtotal</span><span>${formatMoney(cart.original_total_price)}</span></div>
          ${cart.total_discount > 0 ? `
          <div class="cart-drawer__totals-row cart-drawer__totals-row--muted"><span>discounts</span><span>−${formatMoney(cart.total_discount)}</span></div>
          <div class="cart-drawer__totals-row"><span>total</span><span>${formatMoney(cart.total_price)}</span></div>` : ''}
        </div>
        <form action="/cart" method="post"><button type="submit" name="checkout" class="cart-drawer__checkout"><span>checkout</span></button></form>
      `;
    }
    containers.forEach(c => { c.innerHTML = html; });
    try { updateBundlesPage(cart); } catch (e) { console.error('bundles page error', e); }
  } catch (e) { console.error(e); }
}

// Show/hide the persistent wallet-button block (in the drawer shell, outside
// [data-cart-content]) based on cart count, and ask Shopify to (re)initialise
// the accelerated-checkout web component so it reflects the current cart.
function syncWalletButtons(itemCount) {
  const hasItems = itemCount > 0;
  // Logo also lives in the persistent shell (after the wallet block) so the
  // bottom order is checkout → apple pay → logo; toggle it with the cart count.
  const logo = document.querySelector('[data-cart-drawer] [data-cart-logo]');
  if (logo) logo.hidden = !hasItems;

  const wallet = document.querySelector('[data-cart-drawer] [data-cart-dynamic]');
  if (!wallet) return;
  if (hasItems) {
    wallet.hidden = false;
    // The component reads the live cart; re-init makes it re-render after an
    // empty→items transition. Guarded — only present once Shopify's button JS
    // has loaded.
    try {
      if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
        Shopify.PaymentButton.init();
      }
    } catch (_) {}
  } else {
    wallet.hidden = true;
  }
}

function formatMoney(cents) {
  const code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  if (code === 'EUR') return `€${(cents / 100).toFixed(2)}`;
  // Multi-currency (localization picker): format with the active currency
  // instead of hardcoding €, so the JS-rebuilt cart matches checkout.
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100).toLowerCase();
  } catch (_) {
    return `${(cents / 100).toFixed(2)} ${code.toLowerCase()}`;
  }
}

// Size a Shopify CDN image URL for the cart thumbnail instead of loading the
// full-resolution original (which /cart.js returns).
function cartImageUrl(url, width) {
  if (!url || typeof url !== 'string') return url;
  return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
}

// LINE ITEM ACTIONS in drawer
// Serialised with a busy flag: a double-tap on +/− used to fire two racing
// /cart/change.js calls against line numbers that shift between responses.
let cartLineBusy = false;
document.addEventListener('click', async (e) => {
  const up = e.target.closest('[data-qty-up]');
  const down = e.target.closest('[data-qty-down]');
  const rm = e.target.closest('[data-remove]');
  if (!up && !down && !rm) return;
  e.preventDefault();
  if (cartLineBusy) return;
  cartLineBusy = true;
  try {
    const line = parseInt((up && up.dataset.qtyUp) || (down && down.dataset.qtyDown) || (rm && rm.dataset.remove));

    let newQty = 0; // removal needs no current value
    if (up || down) {
      // Only +/- needs the current quantity — read it once.
      const cart = await (await fetch('/cart.js')).json();
      const item = cart.items[line - 1];
      if (!item) return;
      newQty = item.quantity + (up ? 1 : -1);
    }

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity: newQty })
    });
    // refreshCart always refetches /cart.js so the totals + dynamic checkout
    // buttons (Apple Pay etc.) stay in sync.
    await refreshCart();
  } catch (err) {
    console.error(err);
  } finally {
    cartLineBusy = false;
  }
});

// AJAX ADD-TO-CART
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.matches('form[data-product-form]')) return;
  e.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const labels = button.querySelectorAll('span');
  const originalText = labels[0]?.textContent;
  if (labels[0]) labels[0].textContent = 'adding…';
  button.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Add failed');
    if (labels[0]) labels[0].textContent = 'added ✓';
    await refreshCart();
    openDrawer(drawer);
    setTimeout(() => { if (labels[0]) labels[0].textContent = originalText; button.disabled = false; }, 1200);
  } catch (err) {
    if (labels[0]) labels[0].textContent = 'try again';
    setTimeout(() => { if (labels[0]) labels[0].textContent = originalText; button.disabled = false; }, 1500);
  }
});

// SIZE / VARIANT SELECTION
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.size-btn');
  if (!btn) return;
  const form = btn.closest('form');
  if (!form) return;
  const position = btn.dataset.optionPosition;
  // Toggle pressed state within the same option position
  form.querySelectorAll(`.size-btn[data-option-position="${position}"]`).forEach(b => b.removeAttribute('aria-pressed'));
  btn.setAttribute('aria-pressed', 'true');
  // Update label
  const lbl = form.querySelector(`[data-option-value="${position}"]`);
  if (lbl) lbl.textContent = `[ ${btn.dataset.optionValueText} ]`;
  // Update hidden id input
  const idInput = form.querySelector('input[name="id"]');
  if (idInput && btn.dataset.variantId) idInput.value = btn.dataset.variantId;
  // Toggle Add vs Notify CTAs
  const addBtn = form.querySelector('[data-cta-add]');
  const notifyBtn = form.querySelector('[data-cta-notify]');
  const payBtn = form.querySelector('[data-cta-pay]');
  const status = form.querySelector('[data-stock-status]');
  const available = btn.dataset.available === 'true';
  if (addBtn) addBtn.hidden = !available;
  // Hide express checkout for out-of-stock variants (can't buy them).
  if (payBtn) payBtn.hidden = !available;
  if (notifyBtn) {
    notifyBtn.hidden = available;
    notifyBtn.dataset.variantTitle = btn.dataset.optionValueText || '';
  }
  if (status) {
    const inLabel = status.dataset.labelIn || 'ready to ship';
    const outLabel = status.dataset.labelOut || 'out of stock';
    status.textContent = available ? inLabel : outLabel;
    status.classList.toggle('is-out', !available);
  }

  // Update price for the selected variant
  if (btn.dataset.variantId && window.__productData) {
    const variant = window.__productData.variants.find(v => String(v.id) === String(btn.dataset.variantId));
    if (variant) {
      renderCtaPrice(form, variant.price, variant.compare_at_price);
    }
  }
});

// Money must match Liquid's `| money` for this store's EUR format, otherwise
// the price flips from €40,00 to €40.00 the moment JS touches it.
function setMoney(cents) {
  return `€${(cents / 100).toFixed(2).replace('.', ',')}`;
}

// Rebuilds rather than assigning textContent: the compare-at <s> rendered by
// snippets/price.liquid lives inside this span, and textContent would drop it.
function renderCtaPrice(form, priceCents, compareCents) {
  const el = form.querySelector('[data-cta-price]');
  if (!el) return;
  const onSale = compareCents && compareCents > priceCents;
  el.textContent = setMoney(priceCents);
  el.classList.toggle('is-on-sale', !!onSale);
  if (onSale) {
    const s = document.createElement('s');
    s.className = 'price-was';
    s.textContent = setMoney(compareCents);
    el.appendChild(s);
  }
}


// NOTIFY ME MODAL
const notifyModal = document.querySelector('[data-notify-modal]');

function openNotify(productTitle, variantTitle) {
  if (!notifyModal) return;
  // Build tags so each back-in-stock signup is easy to filter in admin → Customers.
  function slugify(s) {
    return (s || 'unknown')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }
  const productSlug = slugify(productTitle);
  const variantSlug = slugify(variantTitle || 'default');
  const tagsInput = notifyModal.querySelector('[data-notify-tags]');
  const firstNameInput = notifyModal.querySelector('[data-notify-firstname]');
  if (tagsInput) {
    tagsInput.value = `back-in-stock, bis-${productSlug}, bis-variant-${variantSlug}`;
  }
  // Stash the product/variant label in first_name so it's visible at a glance in the admin customer list.
  if (firstNameInput) {
    firstNameInput.value = `BIS: ${productTitle || 'unknown'}${variantTitle ? ' / ' + variantTitle : ''}`.slice(0, 100);
  }
  notifyModal.classList.add('is-open');
  notifyModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  setTimeout(() => notifyModal.querySelector('[data-notify-email]')?.focus(), 50);
}

function closeNotify() {
  if (!notifyModal) return;
  notifyModal.classList.remove('is-open');
  notifyModal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-cta-notify]');
  if (trigger) {
    openNotify(trigger.dataset.productTitle, trigger.dataset.variantTitle);
    return;
  }
  if (e.target.closest('[data-notify-close]')) { closeNotify(); return; }
  if (notifyModal && notifyModal.classList.contains('is-open') && e.target === notifyModal) {
    closeNotify();
  }
});

// (Escape handler consolidated above)

// SIZING MODAL
const sizingModal = document.querySelector('[data-sizing-modal]');

// The size-chart markup ships inside a <template> so its (often huge, full
// resolution) images are never fetched until someone actually asks to see the
// chart. Clone it in the first time the modal opens, then drop the template.
function hydrateSizing() {
  if (!sizingModal) return;
  const tpl = sizingModal.querySelector('[data-sizing-content]');
  if (!tpl) return;
  tpl.parentNode.appendChild(tpl.content.cloneNode(true));
  tpl.remove();
}

function openSizing() {
  if (!sizingModal) return;
  hydrateSizing();
  sizingModal.classList.add('is-open');
  sizingModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeSizing() {
  if (!sizingModal) return;
  sizingModal.classList.remove('is-open');
  sizingModal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-sizing-open]')) { openSizing(); return; }
  if (e.target.closest('[data-sizing-close]')) { closeSizing(); return; }
  if (sizingModal && sizingModal.classList.contains('is-open') && e.target === sizingModal) closeSizing();
});

// SOLD-OUT CURSOR LABEL
// A single glass pill on <body> that tracks the pointer while it is over any
// .is-sold-out product. One shared node rather than one per product: .float
// carries a drop-shadow filter and the carousel frame is overflow:hidden, and
// either would trap a fixed child or clip an absolute one.
// Position is written straight to .style.transform in the pointermove handler —
// deliberately NOT rAF-throttled. pointermove already fires at most once per
// frame, and an rAF hop silently does nothing in environments that aren't
// producing frames, which would leave the label stuck at 0,0.
(function setupSoldOutCursor() {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  let label = null;
  let tracking = false;

  function ensureLabel() {
    if (label) return label;
    label = document.createElement('div');
    label.className = 'soldout-cursor';
    label.textContent = 'sold out';
    label.setAttribute('aria-hidden', 'true');
    document.body.appendChild(label);
    return label;
  }

  function move(e) {
    if (!tracking || !label) return;
    label.style.transform = 'translate3d(' + e.clientX + 'px,' + e.clientY + 'px,0)';
  }

  document.addEventListener('pointerover', (e) => {
    const hit = e.target.closest && e.target.closest('.is-sold-out');
    // The carousel shows a permanent tag on the card instead — no follower there.
    if (!hit || hit.closest('.allstrip')) return;
    ensureLabel();
    tracking = true;
    move(e);                       // place it before revealing, so it never flashes at 0,0
    label.classList.add('is-visible');
  });

  document.addEventListener('pointerout', (e) => {
    if (!tracking) return;
    // ignore moves between children of the same sold-out product
    const to = e.relatedTarget;
    if (to && to.closest && to.closest('.is-sold-out')) return;
    tracking = false;
    if (label) label.classList.remove('is-visible');
  });

  document.addEventListener('pointermove', move, { passive: true });

  // A sold-out card can scroll out from under a stationary cursor.
  window.addEventListener('scroll', () => {
    if (tracking && label) { tracking = false; label.classList.remove('is-visible'); }
  }, { passive: true });
})();

// POLICIES TABS
document.addEventListener('click', (e) => {
  const tab = e.target.closest('.policies__tab');
  if (!tab) return;
  const wrap = tab.closest('[data-policies]');
  if (!wrap) return;
  const target = tab.dataset.tab;
  wrap.querySelectorAll('.policies__tab').forEach(t => {
    t.classList.toggle('is-active', t === tab);
    t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
  });
  wrap.querySelectorAll('.policies__panel').forEach(p => {
    const match = p.dataset.panel === target;
    p.hidden = !match;
    p.classList.toggle('is-active', match);
  });
});

// EXPANDABLE PRODUCT DESCRIPTION
// Smoothly open/close the rest of the description by animating its measured
// height (no overshoot) plus a gentle fade. Honours prefers-reduced-motion.
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Cancel any in-flight desc animation cleanly so rapid toggles don't fight.
function clearDescAnim(el) {
  if (el._descDone) { el.removeEventListener('transitionend', el._descDone); el._descDone = null; }
}

function openDesc(el, panel) {
  clearDescAnim(el);
  el.hidden = false;
  // Raise the panel cap up-front so it can grow with the content.
  if (panel) panel.classList.add('info-panel--desc-open');
  if (reduceMotion.matches) { el.style.cssText = ''; return; }
  el.style.overflow = 'hidden';
  el.style.opacity = '0';
  el.style.maxHeight = '0px';
  el.style.transition = 'none';
  // force reflow so the 0px start is committed before we transition to target
  void el.offsetHeight;
  const target = el.scrollHeight;
  el.style.transition = 'max-height 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.32s ease';
  el.style.maxHeight = target + 'px';
  el.style.opacity = '1';
  el._descDone = function (ev) {
    if (ev.propertyName !== 'max-height') return;
    clearDescAnim(el);
    // Release the fixed height so the panel can reflow naturally afterwards.
    el.style.maxHeight = 'none';
    el.style.overflow = '';
    el.style.transition = '';
  };
  el.addEventListener('transitionend', el._descDone);
}

function closeDesc(el, panel) {
  clearDescAnim(el);
  if (reduceMotion.matches) {
    el.hidden = true; el.style.cssText = '';
    if (panel) panel.classList.remove('info-panel--desc-open');
    return;
  }
  el.style.overflow = 'hidden';
  el.style.maxHeight = el.scrollHeight + 'px';
  el.style.transition = 'none';
  void el.offsetHeight;
  el.style.transition = 'max-height 0.34s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.26s ease';
  el.style.maxHeight = '0px';
  el.style.opacity = '0';
  el._descDone = function (ev) {
    if (ev.propertyName !== 'max-height') return;
    clearDescAnim(el);
    el.hidden = true;
    el.style.cssText = '';
    // Only now drop the panel cap back to its collapsed value — the panel has
    // already shrunk with the content, so this no longer causes a jump.
    if (panel) panel.classList.remove('info-panel--desc-open');
  };
  el.addEventListener('transitionend', el._descDone);
}

// First paragraph is always visible; toggle reveals/hides the rest below it.
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-desc-toggle]');
  if (!toggle) return;
  const wrap = toggle.closest('[data-desc]');
  if (!wrap) return;
  const restEl = wrap.querySelector('[data-desc-rest]');
  if (!restEl) return;
  const panel = toggle.closest('.info-panel');
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  if (expanded) { closeDesc(restEl, panel); } else { openDesc(restEl, panel); }
  toggle.textContent = expanded ? '[ + ]' : '[ − ]';
  toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
});

// Show success state after the customer form posts.
// Shopify redirects back with either #contact_posted=true (contact form) or
// #customer_posted=true (customer form). Handle both for backward compatibility.
if (window.location.hash.includes('contact_posted=true') ||
    window.location.hash.includes('customer_posted=true') ||
    window.location.search.includes('customer_posted=true')) {
  const success = document.querySelector('[data-notify-success]');
  const form = document.querySelector('[data-notify-form]');
  if (success && form) {
    success.hidden = false;
    form.style.display = 'none';
    openNotify('', '');
  }
}

// SIGNUP POPUP — email capture on store entry. Shown after a configurable
// delay, at most once per `frequency-days` (localStorage); a successful
// signup (detected via the ?signup=done return_to redirect) suppresses it
// permanently on this device.
const signupPopup = document.querySelector('[data-signup-popup]');

function closeSignupPopup() {
  if (!signupPopup || !signupPopup.classList.contains('is-open')) return;
  signupPopup.classList.remove('is-open');
  signupPopup.setAttribute('aria-hidden', 'true');
  try { localStorage.setItem('wori-signup-seen', String(Date.now())); } catch (_) {}
}

(function initSignupPopup() {
  if (!signupPopup) return;
  const days = parseInt(signupPopup.dataset.frequencyDays, 10) || 30;
  const delay = (parseInt(signupPopup.dataset.delay, 10) || 0) * 1000;

  function open() {
    signupPopup.classList.add('is-open');
    signupPopup.setAttribute('aria-hidden', 'false');
  }

  if (window.location.search.indexOf('signup=done') !== -1) {
    // Back from a successful signup: show the success state briefly and
    // never auto-open again on this device.
    try { localStorage.setItem('wori-signup-done', '1'); } catch (_) {}
    const success = signupPopup.querySelector('[data-signup-success]');
    const form = signupPopup.querySelector('form');
    if (success) success.hidden = false;
    if (form) form.style.display = 'none';
    open();
    setTimeout(closeSignupPopup, 3500);
  } else if (window.Shopify && Shopify.designMode) {
    // Theme editor: open immediately (no delay, ignore localStorage) so the
    // popup can actually be styled from theme settings.
    open();
  } else {
    let seen = 0;
    let done = null;
    try {
      seen = parseInt(localStorage.getItem('wori-signup-seen') || '0', 10);
      done = localStorage.getItem('wori-signup-done');
    } catch (_) {}
    if (!done && Date.now() - seen > days * 86400000) {
      setTimeout(open, delay);
    }
  }

  signupPopup.addEventListener('click', (e) => {
    if (e.target.closest('[data-signup-close]') || e.target === signupPopup) closeSignupPopup();
  });

  // Mark as seen on submit too — if the redirect drops query params for any
  // reason, the visitor still won't be nagged again right away.
  const form = signupPopup.querySelector('form');
  if (form) form.addEventListener('submit', () => {
    try { localStorage.setItem('wori-signup-seen', String(Date.now())); } catch (_) {}
  });
})();

// Tiny debounce helper used by all resize/layout callbacks below.
function debounce(fn, ms) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), ms);
  };
}

// MEASURE the fixed-bottom UI (CTA pill + the full, locked info panel) and set
// --mobile-panel-h so the product image fills exactly the space above them.
// Mobile-only — desktop layout doesn't read these vars.
const mobileMQ = window.matchMedia('(max-width: 749px)');
function syncMobilePanelHeight() {
  if (!mobileMQ.matches) return;
  const panel = document.querySelector('.info-panel');
  if (!panel) return;
  const rect = panel.getBoundingClientRect();
  // Size the image area to END a few px ABOVE the panel's ACTUAL top edge, so the
  // dot selectors (which sit at the bottom of the image area) are never tucked
  // under the panel — even in the Instagram in-app browser where 100dvh and
  // safe-area insets are reported oddly. Measuring the real panel top instead of
  // trusting dvh makes this webview-proof.
  const clearance = 6;
  const carouselH = Math.max(140, Math.floor(rect.top) - clearance);
  document.documentElement.style.setProperty('--carousel-h', `${carouselH}px`);
  // Keep --mobile-panel-h in sync (used by fallback / other consumers).
  document.documentElement.style.setProperty('--mobile-panel-h', `${Math.ceil(window.innerHeight - rect.top) + clearance}px`);
}
if (document.querySelector('.info-stack')) {
  const debouncedSyncPanel = debounce(syncMobilePanelHeight, 120);
  syncMobilePanelHeight();
  window.addEventListener('resize', debouncedSyncPanel, { passive: true });
  mobileMQ.addEventListener('change', syncMobilePanelHeight);
  // The apple pay button hydrates asynchronously and toggles with stock, both of
  // which change the group's height after first paint — re-measure on any resize
  // of the group so the panel offset always matches.
  const ctaGroupEl = document.querySelector('.cta-group');
  if (ctaGroupEl && 'ResizeObserver' in window) {
    new ResizeObserver(debouncedSyncPanel).observe(ctaGroupEl);
  }
  // NOTE: we deliberately do NOT re-measure when the panel grows (e.g. tapping
  // [ + ] to expand the description). The image stays at its collapsed-state size
  // and the expanded panel simply overlays on top of it (it's fixed-position with
  // a higher z-index), instead of shrinking the product photo.
}

// BOTTOM SHEET — swipe up anywhere on the product page to pull the info panel up,
// swipe down to push it back. Bound to <main> so a swipe over the product image
// area (not just the panel) also lifts the sheet.
function setupBottomSheet() {
  const sheet = document.querySelector('.info-panel[data-sheet]');
  if (!sheet) return;
  const surface = document.querySelector('main') || document.body;

  const mq = window.matchMedia('(max-width: 749px)');
  const DRAG_THRESHOLD = 8;
  let startY = 0, startX = 0, lastY = 0;
  let startTime = 0;
  let mayDrag = false, dragging = false, expanded = false;
  let collapsedTranslate = 0;

  function getPeek() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sheet-peek-h')) || 110;
  }

  function computeCollapsedTranslate() {
    return Math.max(0, sheet.offsetHeight - getPeek());
  }

  function snap(toExpanded) {
    expanded = toExpanded;
    sheet.classList.remove('is-dragging');
    sheet.style.transform = '';
    sheet.classList.toggle('is-expanded', expanded);
  }

  function shouldIgnore(target) {
    // Don't hijack swipes that start inside the CTA pill, cart drawer, or modals
    return !!target.closest('.cta-pill, [data-cart-drawer], [data-menu-drawer], .notify-modal, .sizing-modal, .cart-backdrop');
  }

  surface.addEventListener('pointerdown', (e) => {
    if (!mq.matches) return;
    if (shouldIgnore(e.target)) return;
    mayDrag = true;
    dragging = false;
    startY = e.clientY;
    startX = e.clientX;
    lastY = e.clientY;
    startTime = Date.now();
    collapsedTranslate = computeCollapsedTranslate();
  });

  surface.addEventListener('pointermove', (e) => {
    if (!mayDrag) return;
    const dy = e.clientY - startY;
    const dx = e.clientX - startX;

    if (!dragging) {
      if (Math.abs(dy) < DRAG_THRESHOLD) return;
      if (Math.abs(dx) > Math.abs(dy)) { mayDrag = false; return; }
      // Only start a drag in the direction that makes sense for the current state.
      // Collapsed → only an UPWARD swipe should start expansion (so taps + downward
      // swipes on product images still feel natural). Expanded → either direction.
      if (!expanded && dy > 0) { mayDrag = false; return; }
      dragging = true;
      sheet.classList.add('is-dragging');
      try { surface.setPointerCapture(e.pointerId); } catch (_) {}
    }

    if (e.cancelable) e.preventDefault();
    const base = expanded ? 0 : collapsedTranslate;
    const next = Math.max(0, Math.min(collapsedTranslate, base + dy));
    sheet.style.transform = `translateY(${next}px)`;
    lastY = e.clientY;
  }, { passive: false });

  function endDrag(e) {
    if (!mayDrag) return;
    mayDrag = false;
    if (!dragging) return;
    dragging = false;
    const dy = lastY - startY;
    const dt = Date.now() - startTime;
    const base = expanded ? 0 : collapsedTranslate;
    const finalPos = Math.max(0, Math.min(collapsedTranslate, base + dy));
    const isFling = dt < 250 && Math.abs(dy) > 24;
    let toExpanded;
    if (isFling) toExpanded = dy < 0;
    else toExpanded = finalPos < collapsedTranslate / 2;
    snap(toExpanded);
  }

  surface.addEventListener('pointerup', endDrag);
  surface.addEventListener('pointercancel', endDrag);

  mq.addEventListener('change', () => {
    expanded = false;
    sheet.classList.remove('is-expanded', 'is-dragging');
    sheet.style.transform = '';
  });
}
setupBottomSheet();


// ACCELERATED CHECKOUT — show exactly ONE wallet button matched to the platform:
// Apple Pay whenever the device/browser supports it (iPhone, iPad, Mac Safari),
// Shop Pay otherwise. Shopify's <shopify-accelerated-checkout-cart> renders one
// button per entry in its `wallet-configs` JSON attribute (light DOM). So we
// filter that array down to a single preferred-and-available wallet → the
// component renders a single button. Shop Pay is always available, so it's the
// safe fallback that never renders empty.
function setupSingleWallet() {
  function preferred() {
    // ApplePaySession only exists in Safari on Apple hardware, and
    // canMakePayments() confirms the device can actually pay — no UA sniffing
    // needed. This also covers desktop Mac Safari (which the old iOS-only
    // check missed).
    let applePayOK = false;
    try {
      applePayOK = !!(window.ApplePaySession && ApplePaySession.canMakePayments && ApplePaySession.canMakePayments());
    } catch (_) {}
    if (applePayOK) return 'apple_pay';
    return 'shop_pay'; // universally available — never renders empty
  }

  // Reduce wallet-configs to ONE wallet: Apple Pay only on Apple-Pay-capable
  // browsers, Shop Pay only elsewhere. The full original config list is
  // stashed on the element so the fallback below can restore Shop Pay if the
  // Apple Pay button never actually renders (canMakePayments() only says the
  // browser supports Apple Pay — with no card in Wallet, or inside the
  // theme-editor preview, the component silently renders nothing).
  // Idempotent: no write once the attribute already has the right value.
  function filterConfigs(el) {
    const raw = el.getAttribute('wallet-configs');
    if (!raw) return;
    let arr;
    try { arr = JSON.parse(raw); } catch (_) { return; }
    if (!Array.isArray(arr) || !arr.length) return;
    // Keep the richest config list we've seen — once we overwrite the
    // attribute the shop_pay entry is gone from it, so remember the original.
    if (!el.__walletAll || arr.length > el.__walletAll.length) el.__walletAll = arr;
    const pool = el.__walletAll;
    const wantApple = preferred() === 'apple_pay' && !el.__walletFallback;
    let next = pool.filter(w => w && w.name === (wantApple ? 'apple_pay' : 'shop_pay'));
    if (!next.length) next = pool.filter(w => w && w.name === 'shop_pay');
    if (!next.length) next = [pool[0]];
    const json = JSON.stringify(next);
    if (json !== raw) el.setAttribute('wallet-configs', json);
  }

  const WALLET_SEL =
    '.cart-drawer__dynamic[data-cart-dynamic] shopify-accelerated-checkout-cart, ' +
    '.cart-drawer__dynamic[data-cart-dynamic] shopify-accelerated-checkout';

  // DOM-level backstop: the component ignores wallet-configs changes once
  // hydrated, so if it already rendered multiple buttons (config filtering ran
  // too late, e.g. very fast wallet script), hide every cell except the
  // preferred wallet's and let it take the full width.
  function enforceCells(el) {
    const wantApple = preferred() === 'apple_pay' && !el.__walletFallback;
    const cells = el.querySelectorAll('li');
    if (cells.length < 2) return;
    const matches = (cell, key) => {
      const sig = ((cell.innerHTML || '') + ' ' + (cell.className || '')).toLowerCase();
      return sig.indexOf(key) !== -1;
    };
    let target = null;
    cells.forEach(c => {
      if (target) return;
      if (wantApple ? matches(c, 'apple-pay') : matches(c, 'shop-pay')) target = c;
    });
    if (!target && wantApple) {
      cells.forEach(c => { if (!target && matches(c, 'shop-pay')) target = c; });
    }
    if (!target) return; // can't identify the buttons — leave everything visible
    cells.forEach(c => {
      const hide = c !== target;
      if ((c.style.display === 'none') !== hide) c.style.display = hide ? 'none' : '';
    });
    if (target.style.width !== '100%') target.style.width = '100%';
    const grid = target.parentElement;
    if (grid && grid.style.display !== 'block') grid.style.display = 'block';
  }

  function apply() {
    // Runs on every viewport — Apple devices get Apple Pay as the single main
    // wallet on desktop too, not just mobile.
    // Re-query on every apply — the cart drawer (and its dynamic-checkout block)
    // gets (re)inserted by refreshCart, so we can't cache a container list at
    // page load.
    document.querySelectorAll(WALLET_SEL).forEach(el => {
      filterConfigs(el);
      enforceCells(el);
    });
  }

  // FALLBACK: if we asked for apple-pay-only but the component painted nothing
  // (zero height) while its container is supposed to be visible, flip that
  // container to Shop Pay permanently so the slot is never an empty hole.
  function verifyRendered() {
    if (preferred() !== 'apple_pay') return;
    document.querySelectorAll(WALLET_SEL).forEach(el => {
      if (el.__walletFallback || !el.__walletAll) return;
      const wallet = el.closest('[data-cart-dynamic]');
      if (wallet && wallet.hidden) return; // cart empty — nothing should render
      if (el.offsetHeight < 10) {
        el.__walletFallback = true;
        filterConfigs(el);
      }
    });
  }

  // Watch the whole document — covers the drawer being refreshed AND the
  // wallet web component hydrating its internal DOM with the wallet-configs
  // attribute. Cheap because filterConfigs is a no-op once the right value
  // is already on the attribute. Each mutation also re-arms the render check.
  const scheduleVerify = debounce(verifyRendered, 2000);
  new MutationObserver(() => { apply(); scheduleVerify(); }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['wallet-configs', 'hidden']
  });

  apply();
  // Catch the component if it hydrates slightly after first paint.
  setTimeout(apply, 150);
  setTimeout(apply, 600);
  setTimeout(apply, 1600);
  setTimeout(verifyRendered, 2600);
}
setupSingleWallet();


// SCROLL "ACTIVE" SLIDE TRACKING (product images) + thumb pill sync + click-to-navigate
// Skip entirely on mobile where this element is display:none — saves listeners + rect work.
const productScroller = document.querySelector('.product-scroll');
if (productScroller && productScroller.offsetParent !== null) {
  const slides = Array.from(productScroller.querySelectorAll('.product-scroll__slide'));
  const thumbButtons = document.querySelectorAll('.thumb-pill__btn');
  if (slides.length) slides[0].classList.add('is-active');

  function markActiveByIndex(imgIndex) {
    slides.forEach(s => {
      const idx = parseInt(s.dataset.imgIndex, 10);
      s.classList.toggle('is-active', idx === imgIndex);
    });
    thumbButtons.forEach(b => {
      b.classList.toggle('is-current', parseInt(b.dataset.thumbTarget, 10) === imgIndex);
    });
  }

  // Active = whichever slide's center is closest to the scroller's center.
  // This works regardless of slide height vs viewport (the old IntersectionObserver
  // with threshold 0.6 silently failed when slides were shorter than 60% of viewport).
  let activeImgIndex = -1;
  function updateActiveByCenter() {
    if (!slides.length) return;
    const scrollerCenter = productScroller.scrollTop + productScroller.clientHeight / 2;
    let nearest = null;
    let nearestDiff = Infinity;
    for (const s of slides) {
      const c = s.offsetTop + s.offsetHeight / 2;
      const d = Math.abs(c - scrollerCenter);
      if (d < nearestDiff) { nearestDiff = d; nearest = s; }
    }
    if (!nearest) return;
    const idx = parseInt(nearest.dataset.imgIndex, 10);
    if (!isNaN(idx) && idx !== activeImgIndex) {
      activeImgIndex = idx;
      markActiveByIndex(idx);
    }
  }

  let centerTicking = false;
  productScroller.addEventListener('scroll', () => {
    if (centerTicking) return;
    centerTicking = true;
    requestAnimationFrame(() => { updateActiveByCenter(); centerTicking = false; });
  }, { passive: true });
  requestAnimationFrame(updateActiveByCenter);

  // Click on a non-active slide → smooth scroll by ±1 depending on direction relative to current active slide
  productScroller.addEventListener('click', (e) => {
    const slide = e.target.closest('.product-scroll__slide');
    if (!slide || slide.classList.contains('is-active')) return;
    const slideTop = slide.getBoundingClientRect().top;
    const scrollerTop = productScroller.getBoundingClientRect().top;
    const slideMidVsCenter = slideTop + slide.offsetHeight / 2 - scrollerTop - productScroller.clientHeight / 2;
    const direction = slideMidVsCenter < 0 ? -1 : 1;
    smoothScrollByDirection(productScroller, direction);
  });

  // Click on a thumb-pill button → smooth scroll to that image (stay in middle copy)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.thumb-pill__btn');
    if (!btn) return;
    const target = parseInt(btn.dataset.thumbTarget, 10);
    const setSize = parseInt(productScroller.dataset.setSize, 10) || 1;
    // Always target the matching slide in the middle copy — use offsetTop so the
    // flex `gap` between slides is included in the position.
    const targetSlide = slides[setSize + target];
    if (!targetSlide) return;
    const targetTop = targetSlide.offsetTop;

    productScroller.__loop && (productScroller.__loop.suppress = true);
    productScroller.scrollTo({ top: targetTop, behavior: 'smooth' });
    setTimeout(() => {
      if (productScroller.__loop) productScroller.__loop.suppress = false;
    }, 700);
  });
}

// INFINITE LOOP — for any element with [data-loop-scroller]
// Markup contains 3 copies of the items; we keep the user inside the middle copy
// and silently jump them back when they reach the boundaries.
function setupInfiniteLoop(scroller) {
  // Skip hidden scrollers (e.g., desktop product-scroll on mobile) — no point
  // measuring rects or attaching listeners to display:none elements.
  if (scroller.offsetParent === null) return;
  let track = scroller;
  const mobileTrack = scroller.querySelector('.sky__mobile');
  if (mobileTrack && getComputedStyle(mobileTrack).display !== 'none') {
    track = mobileTrack;
  }

  const setSize = parseInt(scroller.dataset.setSize, 10);
  if (!setSize || setSize < 1) return;

  const allItems = Array.from(track.children).filter(el => {
    const cs = getComputedStyle(el);
    return cs.scrollSnapAlign && cs.scrollSnapAlign !== 'none';
  });
  if (allItems.length < setSize * 2) return;

  // Measure set height from actual element positions so it includes any flex `gap`
  let itemHeight = allItems[0].getBoundingClientRect().height;
  let setHeight = (allItems[setSize] ? allItems[setSize].offsetTop : itemHeight * setSize) - allItems[0].offsetTop;

  // Start centered in the middle copy
  requestAnimationFrame(() => { track.scrollTop = setHeight; });

  // Expose API for programmatic scrolling that pauses loop-jumping
  track.__loop = {
    setHeight: () => setHeight,
    setSize,
    suppress: false
  };

  // Rebase the user into the middle copy only AFTER scrolling has settled.
  // Doing it mid-scroll while scroll-snap is engaged is the main cause of glitchy
  // jumps and stutters. We wait ~180ms after the last scroll event, then jump
  // silently by the same delta that puts the user on the same image in the middle copy.
  let settleTimer = null;
  function rebaseIfNeeded() {
    if (track.__loop.suppress) return;
    const y = track.scrollTop;
    // Find nearest snap-eligible slide
    let nearestIdx = -1;
    let nearestDiff = Infinity;
    for (let i = 0; i < allItems.length; i++) {
      const d = Math.abs(allItems[i].offsetTop - y);
      if (d < nearestDiff) { nearestDiff = d; nearestIdx = i; }
    }
    if (nearestIdx < 0) return;
    let targetIdx = -1;
    if (nearestIdx >= setSize * 2) targetIdx = nearestIdx - setSize;       // 3rd copy → middle
    else if (nearestIdx < setSize) targetIdx = nearestIdx + setSize;       // 1st copy → middle
    if (targetIdx < 0) return;
    const delta = allItems[targetIdx].offsetTop - allItems[nearestIdx].offsetTop;
    const prevBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollTop = y + delta;
    track.style.scrollBehavior = prevBehavior;
  }

  track.addEventListener('scroll', () => {
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(rebaseIfNeeded, 180);
  }, { passive: true });

  window.addEventListener('resize', debounce(() => {
    requestAnimationFrame(() => {
      itemHeight = allItems[0].getBoundingClientRect().height;
      setHeight = (allItems[setSize] ? allItems[setSize].offsetTop : itemHeight * setSize) - allItems[0].offsetTop;
      track.scrollTop = setHeight;
    });
  }, 150));
}

document.querySelectorAll('[data-loop-scroller]').forEach(setupInfiniteLoop);

// Helper: smoothly scroll one slide up or down in a loop scroller while keeping the user inside the middle copy.
// Avoids glitches by temporarily suppressing the loop-jump check and rebasing into the middle copy on completion.
function smoothScrollByDirection(track, direction /* -1 up, +1 down */) {
  if (!track.__loop) return;
  const children = Array.from(track.children).filter(el => {
    const cs = getComputedStyle(el);
    return cs.scrollSnapAlign && cs.scrollSnapAlign !== 'none';
  });
  if (!children.length) return;

  track.__loop.suppress = true;
  // Find the slide whose offsetTop is closest to the current scroll position, then step from there
  const y = track.scrollTop;
  let nearestIdx = 0;
  let nearestDiff = Infinity;
  children.forEach((el, i) => {
    const d = Math.abs(el.offsetTop - y);
    if (d < nearestDiff) { nearestDiff = d; nearestIdx = i; }
  });
  const targetIdx = Math.max(0, Math.min(children.length - 1, nearestIdx + direction));
  const targetTop = children[targetIdx].offsetTop;

  track.scrollTo({ top: targetTop, behavior: 'smooth' });

  // After the smooth scroll, rebase scroll into the middle copy if we drifted out
  setTimeout(() => {
    track.__loop.suppress = false;
    const setHeight = track.__loop.setHeight();
    const y = track.scrollTop;
    if (y >= setHeight * 2 || y < setHeight) {
      // Rebase silently
      const offsetWithinSet = ((y % setHeight) + setHeight) % setHeight;
      const prevBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollTop = setHeight + offsetWithinSet;
      track.style.scrollBehavior = prevBehavior;
    }
  }, 600);
}

// ── Product carousel: horizontal swipe + infinite loop + dot sync ────
function initProductCarousel() {
  const carousel = document.querySelector('[data-product-carousel]');
  const dotsWrap = document.querySelector('[data-product-dots]');
  if (!carousel) return;

  const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.product-dot')) : [];
  const setSize = parseInt(carousel.dataset.setSize, 10) || dots.length || 1;
  const slides = Array.from(carousel.querySelectorAll('.product-carousel__slide'));
  // Loop only when we have 3× copies in the DOM (setSize ≥ 2 and at least 3 sets).
  const canLoop = slides.length >= setSize * 3 && setSize >= 2;

  function setActiveDot(index) {
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  function snapToMiddleCopy() {
    // Place the user on the first slide of the middle copy without animation.
    const w = carousel.offsetWidth;
    const prev = carousel.style.scrollBehavior;
    carousel.style.scrollBehavior = 'auto';
    carousel.scrollLeft = w * setSize;
    carousel.style.scrollBehavior = prev;
  }

  if (canLoop) {
    requestAnimationFrame(snapToMiddleCopy);
  }

  let suppress = false;
  let lastJump = 0;
  let ticking = false;

  carousel.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const w = carousel.offsetWidth;
      const x = carousel.scrollLeft;
      const slideIdx = Math.round(x / w);

      // Dot index = which image are we currently on (mod set size)
      const imgIdx = canLoop ? (((slideIdx % setSize) + setSize) % setSize) : slideIdx;
      setActiveDot(imgIdx);

      // Infinite loop: silently rebase to middle copy when we drift to the edges
      if (canLoop && !suppress) {
        const setWidth = w * setSize;
        const now = performance.now();
        if (now - lastJump > 250) {
          if (x >= setWidth * 2) {
            const prev = carousel.style.scrollBehavior;
            carousel.style.scrollBehavior = 'auto';
            carousel.scrollLeft = x - setWidth;
            carousel.style.scrollBehavior = prev;
            lastJump = now;
          } else if (x < setWidth) {
            const prev = carousel.style.scrollBehavior;
            carousel.style.scrollBehavior = 'auto';
            carousel.scrollLeft = x + setWidth;
            carousel.style.scrollBehavior = prev;
            lastJump = now;
          }
        }
      }
      ticking = false;
    });
  }, { passive: true });

  // Click dot → jump to that image in the middle copy
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.dotIndex, 10);
      const targetSlideIdx = canLoop ? (setSize + index) : index;
      suppress = true;
      carousel.scrollTo({ left: targetSlideIdx * carousel.offsetWidth, behavior: 'smooth' });
      setTimeout(() => { suppress = false; }, 700);
    });
  });

  // Keep the user re-centered on the middle copy after resize / rotation (debounced)
  window.addEventListener('resize', debounce(() => {
    if (canLoop) requestAnimationFrame(snapToMiddleCopy);
  }, 150));
}

document.addEventListener('DOMContentLoaded', initProductCarousel);
